/**
 * Chakra <Card>: white, radius lg, hairline `sm` shadow, zero inner padding (compose your own).
 * Variants: elevated (default) · sunken (sand.100, no shadow) · navy (inverse).
 * SectionCard / StatCard in src/components/ui are the usual entry points; use Card directly only for ad-hoc surfaces.
 */
const zeroPadding = { "--card-padding": "0" };

export const Card = {
  baseStyle: {
    container: { "--card-radius": "radii.lg", "--card-bg": "colors.surface.card", bg: "surface.card", borderRadius: "lg", boxShadow: "sm", color: "text.primary" },
    header: { p: 0 },
    body: { p: 0 },
    footer: { p: 0 },
  },
  sizes: {
    sm: { container: { "--card-radius": "radii.lg", ...zeroPadding } },
    md: { container: { "--card-radius": "radii.lg", ...zeroPadding } },
    lg: { container: { "--card-radius": "radii.lg", ...zeroPadding } },
  },
  variants: {
    elevated: { container: { bg: "surface.card", boxShadow: "sm" } },
    sunken: { container: { bg: "surface.sunken", boxShadow: "none" } },
    navy: { container: { bg: "navy.900", color: "white", boxShadow: "none" } },
  },
  defaultProps: { variant: "elevated", size: "md" },
};
